<template>
    <v-tooltip 
        bottom
        v-model="show"        
        :userNumber="userNumber" 
        content-class="tooltip-native ma-0 pa-0"
    >
        <template v-slot:activator="{}">
            <span 
                role="button"
                class="phone-number" 
                color="primary" 
                dark 
                @click="showTooltip">{{ userNumber }}</span>
        </template>

        <div class="tooltip-msg elevation-10 py-4 px-2">
            <v-btn
                block
                small
                color="green"
                class="mb-2 text-capitalize"
                @click="show = !show"
            >
                <v-icon class="mr-1" x-small>mdi-phone-outline</v-icon>
                <span>Позвонить</span>
            </v-btn>
            <v-btn
                block
                small                
                color="amber"
                class="text-capitalize"
                @click="show = !show"
            >
                <v-icon class="mr-1" x-small>mdi-email-outline</v-icon>
                <span>Отправить СМС</span>
            </v-btn>
        </div>
    </v-tooltip>
</template>

<script>
export default {
    name: 'PhoneNumberTooltip',

    props: {
        userNumber: {
            type: String,
            default: undefined
        }
    },

    data: function () {
        return {
            show: false
        }
    },

    methods: {
        showTooltip() {
            this.show = !this.show

            setTimeout(() => {
                if (this.show) {
                   this.show = !this.show 
                }                
            }, 4500);
        }
    }
}
</script>

<style lang="scss" scoped>

.tooltip-native {    
    pointer-events: auto;
    opacity: 1 !important;
}

.phone-number {
    cursor: pointer;
}

.phone-number:hover {
    color: #0051ff;
    transition: 0.2s;
}

.tooltip-msg {
    position: relative;
    width: 120%;
    background-color: rgba(255, 255, 255, 1.0) !important;
    opacity: 1;
}

// треугольник над всплывающим окном

.tooltip-msg::before {
    content: "";
    position: absolute;
    top: -6px;
    left: calc(50% - 3px);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #fff transparent;
}

</style>

